import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/modal/Modal'
import ModalButton from 'components/modal/ModalButton'
import ReportContent from 'components/modal/ReportContent'

const ReportModal = props => {
  const { onReport, ...rest } = props

  return (
    <Modal
      {...rest}
      spaceTop
      spaceBottom
      actions={[
        <ModalButton
          key="photos"
          testId="report-photos"
          title="Inappropriate Photos"
          onClick={onReport({ id: 1, text: 'Inappropriate Photos' })}
        />,
        <ModalButton
          key="spam"
          testId="report-spam"
          title="Feels like Spam"
          onClick={onReport({ id: 2, text: 'Feels like Spam' })}
        />,
        <ModalButton
          key="other"
          testId="report-other"
          title="Other Reason"
          onClick={onReport({ id: 3, text: 'Other Reason' })}
        />
      ]}
    >
      <ReportContent />
    </Modal>
  )
}

ReportModal.propTypes = {
  onReport: PropTypes.func
}

ReportModal.defaultProps = {
  onReport: () => () => {}
}

export default ReportModal



// WEBPACK FOOTER //
// ./src/components/modal/ReportModal.js